'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styles$2 = require('./styles-424066e0.js');

var MailTo = function (_a) {
    var subject = _a.subject, title = _a.title, mailTo = _a.mailTo, rest = tslib_es6.__rest(_a, ["subject", "title", "mailTo"]);
    return (React__default.createElement(styles$2.StyledMailTo, tslib_es6.__assign({ href: "mailto:" + mailTo + "?subject= " + subject }, rest), title));
};

exports.MailTo = MailTo;
